import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { http, errMsg } from "@/lib/data";

export default function AlertAction({ kind }) {
  const { action, token } = useParams();
  const [st, setSt] = useState({ loading: true });
  useEffect(() => {
    http.post(`/${kind}/${action}/${token}`).then((r) => setSt({ data: r.data })).catch((e) => setSt({ error: errMsg(e) }));
  }, [kind, action, token]);
  const ok = st.data && (action === "confirm" ? st.data.status !== "cancelled" : true);
  return (
    <div data-testid="alert-action-page" className="max-w-xl mx-auto px-4 py-24 text-center">
      {st.loading ? <Loader2 className="w-10 h-10 animate-spin mx-auto text-slate-400" /> : ok ? (
        <>
          <CheckCircle2 className="w-14 h-14 text-[#10B981] mx-auto" />
          <h1 data-testid="alert-action-title" className="font-display text-3xl font-extrabold mt-4">{kind === "digests" ? (action === "confirm" ? "Price summary activated" : "Unsubscribed") : action === "confirm" ? "Alert activated" : "Alert stopped"}</h1>
          {kind === "digests" ? <p data-testid="alert-action-detail" className="text-slate-600 mt-2">{st.data.label}{action === "confirm" && " · every 3 days at 8:00 AM IST."}</p> : <p className="text-slate-600 mt-2">{st.data.label} · {st.data.condition} {st.data.target.toLocaleString("en-IN")}{action === "confirm" && (st.data.status === "triggered" ? " — already triggered." : ". We check every 15 minutes.")}</p>}
        </>
      ) : (
        <><XCircle className="w-14 h-14 text-red-500 mx-auto" /><h1 className="font-display text-2xl font-bold mt-4">{st.error || (kind === "digests" ? "This price summary is no longer active" : "This alert is no longer active")}</h1></>
      )}
      <Link to="/markets" className="inline-block mt-8 h-11 leading-[44px] px-6 rounded-xl bg-[#1E293B] text-white font-bold">Back to live markets</Link>
    </div>
  );
}
